import { Container } from "@mui/material";
import BoardMember from "./boardMember";

import kip from "../../images/board/kipKilen.jpg"
import tim from "../../images/board/Tim_New.jpg"
import benton from "../../images/board/bentonCampbell.jpg"
import holly from "../../images/board/Holly.jpg"
import scott from "../../images/board/Scott.jpeg"
import will from "../../images/board/Will.jpeg"
import bob from "../../images/board/Bob.jpg"

const members = [
  {
    name: "Holly Souza",
    bio: "MLUA Board Chair. (Term ends 2026).", 
    email: "hollycape24@gmail.com",
    picture: holly,
  },
  {
    name: "Will Donovan",
    bio: "MLUA Vice-Chair (Term ends 2027)",
    email: "willdonovan@live.com",
    picture: will,
  },
  {
    name: "Tim Likes",
    bio: "MLUA Treasurer (Term ends 2026). Also serves as the Coordinator for Referee development for U.S. Lacrosse in 7 states.",
    email: "chevylikscape@hotmail.com",
    picture: tim,
  },
  {
    name: "Benton Campbell",
    bio: "MLUA Secretary (Term ends 2027).",
    email: "bentonc7@gmail.com",
    picture: benton,
  },
  {
    name: "Bob Hessler",
    bio: "MLUA Director (Term ends 2027).",
    email: "wildfan@rocketmail.com",
    picture: bob,
  },
  {
    name: "Scott Reed",
    bio: "MLUA Director (Term ends 2026).",
    email: "leinereed@gmail.com",
    picture: scott,
  },
  {
    name: "Kip Kilen",
    bio: "MLUA Director. (Term ends 2026).", 
    email: "coachkk2@gmail.com",
    picture: kip,
  },
]

export default function Board() {
  return (
    <Container maxWidth="lg">
      <h1>Meet the Board</h1>
      {members.map((member) => {return <BoardMember {...member} />})}
    </Container>

  );
}